import { post } from "../client";
import { LOGIN, VERIFY_OTP } from "../routes";

export default {
  login: async (data) => await post(LOGIN, data, false),

  verify: async (data) => await post(VERIFY_OTP, data, false),
};
